import { ACCESSORIES_PRICING_URL } from "../../utils/EmpUtil";
import axios from "axios";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { is401 } from "../../errors/ErrorConstants";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";

export default class AccessoriesSearchClient {
  static baseUrl = ACCESSORIES_PRICING_URL;

  static getCategories(user, model, year) {
    const url = `${this.baseUrl}/accessories/search/categories?model=${model}&year=${year}`;
    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data.result.categories;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static downloadAccessories(user, selectedMarket) {
    const url = `${this.baseUrl}/accessories/search/downloadAccesoriesEU?market=${selectedMarket}`;
    const universalBOM = "\uFEFF";
    return axios
      .get(url, getHeaders(user.token))
      .then((response) => encodeURIComponent(`${universalBOM}${response.data}`))
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}
